export const pause = ms => {
  console.log(`pause for ${ms}ms`);
  return new Promise(resolve => {
    setTimeout(resolve, ms);
  });
};
